// extracted by mini-css-extract-plugin
module.exports = {"description":"HeaderDescription_description__qHA7C"};